(function () {
  "use strict";

  // Variables
  const nav = document.querySelector(".nav");
  const progressFill = document.getElementById("navProgressFill");
  const heroScroll = document.getElementById("heroScroll");
  const navDivider = document.getElementById("navDivider");
  const toTop = document.querySelector(".to-top");
  const yearElement = document.getElementById("year");

  // Entrance: divider loads
  function runEntrance() {
    navDivider.classList.add("nav__divider--shown");
  }
  setTimeout(runEntrance, 120);

  // // Remove index.html from the URL for the homepage
  if (window.location.pathname.endsWith("/index.html")) {
    const cleanPath = window.location.pathname.replace(/index\.html$/, "");
    history.replaceState(
      null,
      "",
      cleanPath + window.location.search + window.location.hash,
    );
  }

  // Prevent default behavior for links with href starting with "#" but scroll to target
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const targetId = link.getAttribute("href").substring(1);
      if (targetId) {
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: "smooth" });
        }
      }
    });
  });

  // Handle broken images - remove if failed to load
  document.querySelectorAll("img").forEach((img) => {
    const handleBrokenImage = () => {
      img.remove();
    };

    // Check if image is already broken (complete property means load attempt finished)
    if (img.complete && img.naturalHeight === 0) {
      handleBrokenImage();
    }

    // Listen for images that fail to load after page load
    img.addEventListener("error", handleBrokenImage);
  });

  // Set dynamic year in footer
  if (yearElement) {
    yearElement.textContent = new Date().getFullYear();
  }

  /* Scroll Handler */
  function onScroll() {
    let scrollTop = window.pageYOffset;
    let docHeight = document.documentElement.scrollHeight - window.innerHeight;
    let scrollRange = heroScroll.offsetHeight - window.innerHeight;

    // Progress bar (full page)
    let pctTotal = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
    progressFill.style.width = pctTotal + "%";

    // Nav: white bg after 60px
    // Scroll Top: change opacity after 60px
    if (scrollTop > 60) {
      nav.classList.add("nav--scrolled");
      toTop.style.opacity = "1";
    } else {
      nav.classList.remove("nav--scrolled");
      toTop.style.opacity = "0";
    }
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
})();
